export class User {
  applicationId!: string;
  authType?: 'user_password' | 'client_credentials';
  tenantId?: string;
  email!: string;
  hasPassword?: boolean;
  hasClientSecret?: boolean;
  status!: string;
  user!: string;

  paramValues: {
    firstName?: string;
    lastName?: string;
    company?: string;
    country?: string;
    phone?: string;
    city?: string;
    zipCode?: string;
    taxID?: string;
    mailMode?: string;
    mailNameLabel?: string;
    smtpHost?: string;
    smtpPort?: string;
    smtpIsSafe?: string;
    smtpUser?: string;
    smtpPassword?: string;
    smtpEmailFrom?: string;
    [key: string]: string | undefined;
  } = {};

  setParams(params: {idParam: number, value: string, key: string}[]) {
    if (!params) {
      return null;
    }
    if (!this.paramValues) {
      this.paramValues = {};
    }
    for (let param of params) {
      this.paramValues[param.key] = param.value;
    }
    return null;
  }
}
